import React from "react";
import { IconButton as MaterialUIIconButton, withStyles, } from "@material-ui/core";
import Tooltip from "../features/common/Tooltip";
import FadeIn from "react-fade-in";
import TypedIcon from "../features/common/TypedIcon";
const Button = withStyles({
    root: { "& > *": { color: "white" } },
})(MaterialUIIconButton);
const IconButtonBase = ({ onClick, tooltip, children, className, title, style, size, id, type = "material-icons", identification, disabled, square, color, }) => (<Tooltip title={tooltip || ""}>
    <Button onClick={onClick} className={className} style={{
        borderRadius: title || square ? 8 : undefined,
        width: title ? undefined : 42,
        ...style,
    }} data-identification={identification} id={id} disabled={disabled}>
      <TypedIcon type={type} size={size} title={title} style={{ color }}>
        {children}
      </TypedIcon>
      {title}
    </Button>
  </Tooltip>);
export const IconButton = (props) => {
    return props.disableFadeIn ? (<IconButtonBase {...props}/>) : (<FadeIn>
      <IconButtonBase {...props}/>
    </FadeIn>);
};
